import { LitElement, html, css } from 'lit';
import { property ,customElement} from 'lit/decorators.js';
import { ECharts } from 'echarts/core';

declare const echarts: any;
@customElement('echarts-component')
export class EChartsComponent extends LitElement {
  // Use a static getter for styles if you need to style your component
  static get styles() {
    return css`
      :host {
        display: block;
      }
      #chart-container {
        width: 100%;
        height: 400px;
      }
    `;
  }

  // Initialize properties
  @property({ type: Object }) chartInstance: ECharts | null = null;;

  firstUpdated() {
    const chartDom = this.shadowRoot!.getElementById('chart-container');
    this.chartInstance = echarts.init(chartDom);
    const option = {
      title: {
        text: 'BUFFER'
      },
      tooltip: {
        trigger: 'axis'
      },
      legend: {
        data: ['Distance NM']
      },
      grid: {
        left: '3%',
        right: '4%',
        bottom: '3%',
        containLabel: true
      },
      xAxis: {
        type: 'category',
        boundaryGap: false,
        data: ['13.00', '14.00', '15.00', '16.00', '17.00']
      },
      yAxis: {
        type: 'value'
      },
      series: [
        {
          name: 'Distance NM',
          type: 'line',
          data: [0, 0, 0, 0, 0,0],
          smooth: true,
          itemStyle: {
            color: 'orange'
          }
        },
        {
            name: 'Distance NM',
            type: 'line',
            data: [0, 0, 0, 0.2,-0.1, 0],
            smooth: true,
            itemStyle: {
              color: '#005487'
            }
          },
        // Add another series if needed
      ]
    };
    this.chartInstance!.setOption(option);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    if (this.chartInstance) {
      this.chartInstance.dispose();
    }
  }

  render() {
    return html`
      <div id="chart-container"></div>
    `;
  }
}
